// extracted by mini-css-extract-plugin
module.exports = {"cardImage":"styles_cardImage__2cGw3","box":"styles_box__3iOwh","link":"styles_link__1zF2l","buttonContainer":"styles_buttonContainer__2T9E2","pricebox":"styles_pricebox__3mLpl"};